module.exports = __webpack_public_path__ + "static/media/video-watch-taggis-taggis.89b489af.jpg";